<template>
    <div class="plusMinusInput d-flex align-items-center">
        <button @click="qpc.quantity>minimum_unit ? qpc.quantity-- : minimum_unit "
                type="button" class="btn btn-decrement" id="decrement" :disabled="qpc.quantity<=minimum_unit">-</button>
        <input type="text" class="form-control quantity-num"  name="Qty" v-model="qpc.quantity" @keyup="onlyNumeric">
        <button type="button"
                @click="qpc.quantity>0 ? qpc.quantity++ : minimum_unit "
                class="btn btn-increment">+</button>


        <!--                                                        <button class="btn btn-decrement" id="decrement">-</button>-->
        <!--                                                        <input class="form-control quantity-num" v-model="items.qty" type="number" min="1"-->
        <!--                                                               @changed="update_cart()" />-->
        <!--                                                        <button class="btn btn-increment" @click.prevent="incrementQty" id="increment">+</button>-->
    </div>
</template>
<script>
export default {
    name:"QuantityBox",
    props:{
        minimum_unit:{
            default:1
        },
        quantity:{
            default:1
        },
        immediate:{
            default:true
        }
    },
    data() {
        return {
            qpc: {
                size_id: 0,
                quantity: this.minimum_unit>this.quantity?this.minimum_unit:this.quantity,
                amount:0,
            },
        }
    },
    watch: {
        quantity(n){
            this.qpc.quantity=this.minimum_unit>this.quantity?this.minimum_unit:this.quantity
        },
        minimum_unit(n){
            this.qpc.quantity=this.minimum_unit>this.quantity?this.minimum_unit:this.quantity
        },

        'qpc.quantity': {
            immediate:true,
            handler(items,old) {
                this.$emit('input', items);
                if ((typeof old !== 'undefined' && this.immediate!=false)|| old){
                    this.$emit('changed',items);
                }
            },
            deep: true
        },
    },
    methods: {

    },
}
</script>
